import Vue from "vue";
import * as types from "../mutation-types";
import axios from "../../api/api.config.js";

const state = {
  editOrderId: "",
  fromWhere: "",
  menus: [],
  userMenus: [],
  cardJumpSelf: { url: null, param: {} },
  userInfoCatch: {},
  transportIdOfReceipt: "",
  transportNoOfReceipt: "",
  taskIdOfReceipt: "",
  taskNoOfReceipt: "",
  againOrderId: "",
  exceptNo: "",
};

const getters = {
  editOrderId: (state) => state.editOrderId,
  fromWhere: (state) => state.fromWhere,
  menus: (state) => state.menus,
  userMenus: (state) => state.userMenus,
  cardJumpSelf: (state) => state.cardJumpSelf,
  userInfoCatch: (state) => state.userInfoCatch,
  transportIdOfReceipt: (state) => state.transportIdOfReceipt,
  transportNoOfReceipt: (state) => state.transportNoOfReceipt,
  taskIdOfReceipt: (state) => state.taskIdOfReceipt,
  taskNoOfReceipt: (state) => state.taskNoOfReceipt,
  againOrderId: (state) => state.againOrderId,
  exceptNo: (state) => state.exceptNo,
};

const actions = {
  setParam({ commit }, [key, value]) {
    commit(types.SET_PARAM, [key, value]);
  },
  // 获取用户路由菜单
  getUserMenu({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/v1/menus/mine")
        .then((res) => {
          // this.$store.dispatch('setParam', ['menus', this.menus])
          if (res.data.code === "") {
            commit("SET_USER_MENU", res.data.items);
            resolve(res.data.items);
          } else {
            reject(res.data.message);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setExceptNo({ commit }, payload) {
    commit("SET_EXCEPT_NO", payload);
  },
};

const mutations = {
  [types.SET_PARAM](state, [key, value]) {
    Vue.set(state, key, value);
  },
  SET_USER_MENU(state, data) {
    state.userMenus = data;
  },
  SET_EXCEPT_NO(state, data) {
    state.exceptNo = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/param.js